import React, { useContext } from "react";
import { MDBBtn, MDBIcon, MDBRow } from "mdbreact";
import { Formik } from "formik";

import Spinner from "../spinner";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import {
  ENDPOINT_CREATE_MESSAGE,
  ENDPOINT_CREATE_NOTIFICATION
} from "../../helpers/endpoints";
import axios from "../../helpers/axios";
export default function InputMessage({
  postId,
  sendMessage,
  sendNotification
}) {
  const { userId, creator } = useSelector(state => ({
    ...state.User,
    ...state.Post
  }));
  const alert = useAlert();

  return (
    <MDBRow className="inputMessage">
      <Formik
        initialValues={{ message: "" }}
        validate={values => {
          var errors = {};
          if (values.message.trim().length > 255) {
            errors.username = "No more 255 characters";
            return errors;
          }

          if (values.message.trim().length === 0) {
            errors.username = "required";
            return errors;
          }
          return errors;
        }}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          try {
            const { data } = await axios.post(ENDPOINT_CREATE_MESSAGE, {
              content: values.message,
              postId,
              userId
            });
            if (data) {
              sendMessage(data);
              if (userId != creator) {
                const { data: dataNotification } = await axios.post(
                  ENDPOINT_CREATE_NOTIFICATION,
                  {
                    post: postId,
                    message: data._id,
                    user: creator
                  }
                );
                sendNotification(dataNotification);
              }
            }
          } catch (err) {
            alert.error("Error");
            setSubmitting(false);
          }
          resetForm();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <input
              id="message"
              name="message"
              value={values.message}
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete="off"
              placeholder="escribe tu mensaje"
              disabled={isSubmitting}
            />

            <MDBBtn type="submit" className="btn-send" disabled={isSubmitting}>
              <MDBIcon icon="send" />
            </MDBBtn>
          </form>
        )}
      </Formik>
    </MDBRow>
  );
}
